import React from 'react';

import Head from 'next/head';

import Footer from '@/components/Footer';
import Header from '@/components/Header';
import SignupFormContactInfo from '@/components/SignupForm/ContactInfo';

const Contact = () => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>

      <link rel="canonical" href="https://callapro.com/signup/" />
    </Head>
    <Header />
    <SignupFormContactInfo />
    <Footer />
  </div>
);

export default Contact;
